/*
 * Copyright (c) 2022. American Express Company
 */

// third-party
import React from 'react';

// models and services
import { IncomeSourceModel } from 'src/types/income-source.model';

// components
import Dropdown from '../menus/Dropdown';
import { FieldControl, Label } from '@americanexpress/dls-react';
import InfoCallout from '../callout/InfoCallout';
import LiteralsService from '../../services/literals/LiteralsService';
import Selectors from 'src/utils/selectors';

interface JobPickerProps {
    label: string;
    value: string;
    onChange: (e: any) => void;
    incomeSources: IncomeSourceModel[];
    hasInvalidIncome: boolean;
}

export default function JobPicker(props: JobPickerProps): JSX.Element {
    return (
        <div className="drawerSection" data-cy={Selectors.PlanAhead.JOB_PICKER}>
            <FieldControl>
                <Label htmlFor="incomeSourceId">{props.label}</Label>
                <Dropdown value={props.value} onChange={props.onChange} fullWidth id="incomeSourceId">
                    <option key="source_none" />
                    return
                    {props.incomeSources.map((incomeSource: IncomeSourceModel) => {
                        return (
                            <option key={incomeSource.incomeUid} value={incomeSource.incomeUid}>
                                {incomeSource.name}
                            </option>
                        );
                    })}
                </Dropdown>
            </FieldControl>
            {props.hasInvalidIncome && <InfoCallout text={LiteralsService.getLiteral('JobPicker.noIncome')} noMargin />}
        </div>
    );
}
